import React, { useState } from 'react';
import './Survey.css';


// Survey form for users to explain their strategy and decisions.
// Tracks feedback input and shows placeholder decision/consequence text.
// Submits the form to complete the process.

function Survey() {
    let [feedback, setFeedback] = useState('');
    let [decision, setDecision] = useState('decision placeholder');
    let [consequence, setConsequence] = useState('consequence placeholder');


    const handleFeedback = (event) => {
        setFeedback(event.target.value);
    }

    const loadDecision = (event) => {
        setDecision(' xxxxx.');
    }

    const loadConsequence = (event) => {
        setConsequence(' xxxxx.');
    }

    const submit = () => {
        console.log('submit attempted')
    }

    return (
        <div>
            <form action="/complete" method="get">
                <div style={{ textAlign: 'center' }}>
                    <h2>
                        Final Questionaire
                    </h2>
                    <p>
                        Your team selected: {decision}
                    </p>
                    <p>
                        This will: {consequence}
                    </p>
                    <textarea name='reasoning'
                        cols="60" rows="10"
                        value={feedback}
                        onChange={handleFeedback}
                        placeholder='Justify your strategy and explain your reasoning'>
                    </textarea>
                    <div>
                        <button onClick={submit}>
                            Submit
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default Survey;